<template>
  <div class="panel" v-click-outside="panel_close" @click="panel_toggle">
    <div class="panel__avatar" v-if="is_authenticated()">
      <img class="panel__symbol" :src="avatar + '&background=0A76BD'" :alt="name"  />
    </div>
    <div class="panel__burger" v-else>
      <vb-icon :name="'hamburger'" :color="sass('primary')" :size="23" />
    </div>

    <panel-navigation v-show="links_open" :name="name" />
  </div>
</template>

<script>
import { get_config } from "@src/utilities"
import PanelNavigation from './panel-navigation.vue'

export default {
  name: 'panel',

  components: {
    'panel-navigation': PanelNavigation,
  },

  props: {
    variant: {
      type: String,
      default: 'light',
    },
  },

  data() {
    return {
      avatar: '',
      name: '',
      links_open: false,
    }
  },

  computed: {
  },

  created() {
    window.addEventListener('scroll', () => {
      this.links_open = false
    })
  },

  mounted() {
    this.avatar = get_config('integration.avatarSrc', '')
    this.name = get_config('integration.displayName', '')
  },

  methods: {

    panel_close() {
      this.links_open = false
      document.body.classList.remove('menuOpen')
    },

    panel_toggle() {
      this.links_open = !this.links_open
      this.links_open ? document.body.classList.add('menuOpen') : document.body.classList.remove('menuOpen')
    },
  },
}
</script>

<style lang="scss">

  .panel {
    border: 1px solid $gray-300;
    padding: 10px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    background-color: $white;
    position: relative;
    cursor: pointer;

    &__avatar {
      width: 30px;
      height: 30px;
      overflow: hidden;
      border-radius: 50%;

      img {
        max-width: 100%;
      }
    }
  }

</style>